var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('background:'+ '#f7f7f7'),attrs:{"id":"app"}},[_c('Header'),_c(_vm.MainName,{tag:"component"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }